export default __webpack_public_path__ + "static/fun1-cc97da402f2609b49b31b1224eaafab3.png";